/**
 * 示例-编辑页
 * luxinwen
 * 2023-01
 */
<template>
  <div class="page">
    <div class="page-main">
      <div class="page-main-content">
        <div class="page-main-content-thead">编辑页示例</div>
        <div class="flex-list">
          <div class="flex-list-item" v-for="(item, index) in list" :key="'item' + index" @click="showDetail(item.subTitle)">
            <p>{{ item.title }}</p>
            <span>{{ item.subTitle }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {
            title: '普通编辑页',
            subTitle: 'Default'
          },
          {
            title: '带栏目标题',
            subTitle: 'Title'
          },
          {
            title: '带表单较验',
            subTitle: 'Validate'
          }
        ]
      };
    },
    methods: {
      /**
       * 查看详情
       */
      showDetail(type) {
        this.$router.push({
          name: 'testEdit' + type
        });
      }
    }
  };
</script>